import axiosOrders from '../../axios/quickOrders';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';

const JSEncrypt = require( 'node-jsencrypt' );

const state = {

    taxRate         : 0.07, // totalTicketAmount * 0.07 = 7% of bill,
    orderTip        : 0.00,
    tipValue        : 0.2,
    currentTab      : JSON.parse( localStorage.getItem( 'cart' ) ) || [],
    orderError      : null,
    saveCard        : false,
    orderNote       : '',
    thisOrderNumber : ''
};

const mutations = {

    addItem( state, item ){

        item.id = Math.random().toString( 36 ).substr( 2, 9 );
        state.currentTab.push( item );
        localStorage.setItem( 'cart', JSON.stringify( state.currentTab ) );
    },
    removeItem( state, id ){

        const items = [ ...state.currentTab ]; // a little 'immutable' way of changing state... probably..
        const newList = items.filter( function( item ){

            return item.id != id;
        });
        state.currentTab = newList;
        localStorage.setItem( 'cart', JSON.stringify( newList ) );
    },
    saveEditing( state, data ){

        state.currentTab = [

            ...state.currentTab.filter( item => item.id !== data.id )
        ];
        state.currentTab.push( data );
        localStorage.setItem( 'cart', JSON.stringify( state.currentTab ) );
    },
    clearTab( state ){

        state.currentTab = [];
        localStorage.removeItem( 'cart' );
    },
    updateTab( state, newTab ){

        state.currentTab = newTab;
        localStorage.setItem( 'cart', JSON.stringify( newTab ) );
    },
    updateTip       : ( state, value ) => state.orderTip = parseFloat( value || 0 ).toFixed( 2 ),
    orderError      : ( state, value ) => state.orderError = value,
    toggleTab       : state => state.tabOpen = !state.tabOpen,
    updateNote      : ( state, value ) => state.orderNote = value,
    toggleSaveCard  : state => state.saveCard = !state.saveCard,
    updateTipValue  : ( state, value ) => state.tipValue = value,
    thisOrderNumber : ( state, value ) => state.thisOrderNumber = value
};

const actions = {

    addItem( { commit }, item ){

        commit( 'addItem', item );
    },
    removeItem( { commit, getters, dispatch }, item ){

        commit( 'removeItem', item.id );
        dispatch( 'setTip', getters.tipValue );
    },
    saveEditing( { commit, getters, dispatch, rootGetters }, item ){

        commit( 'saveEditing', item );
        if( rootGetters.previousRoute.name == 'order-tab' ) router.push( { name : 'order-tab' } );
        dispatch( 'orderMenu/clearEditing', null, { root: true } );
    },
    clearTab( { commit, rootGetters } ){

        commit( 'clearTab' );
        if( rootGetters.currentRoute.name == 'order-tab' ) commit( 'updateTip', 0 );
    },
    submitOrder( { commit, getters, dispatch, rootGetters }, encryptedPaymentDetails ){

        if( parseInt( rootGetters[ 'merchant/currentLocation' ].acceptingOrders ) == 1 ){

            let formattedTab = [];
            state.currentTab.forEach( item => {

                if( item.available != 0 ){

                    let newModList = [];
                    item.modifiers.forEach( mod => { // strip out the modifier metadata, only send the modId to the API

                        let splitMod = mod.split( "_" );
                        newModList.push( splitMod[ 3 ] );
                    });
                    formattedTab.push({

                        ...item,
                        modifiers : newModList
                    });
                }
            });

            axiosOrders({

                method: 'post',
                url: '/createOrder',
                data: qs.stringify({

                    merchantId         : rootGetters[ 'merchant/currentMerchant' ].merchantId,
                    merchantLocationId : rootGetters[ 'merchant/currentLocation' ].locationId,
                    items              : window.btoa( JSON.stringify( formattedTab ) ),
                    payment            : encryptedPaymentDetails,
                    tax                : getters.getTax,
                    tip                : state.orderTip,
                    saveCard           : state.saveCard,
                    orderNote          : state.orderNote
                })
            }).then( res => {

                console.log( 'result: ', res );

                // let response = res.data.responseCode;
                // console.log( 'typeof response code: ', typeof response );
                // console.log( 'response code: ', response );

                if( res.data.responseCode == 100 ){ // order worked

                    commit( 'orderError', null );
                    commit( 'clearTab' );
                    commit( 'thisOrderNumber', res.data.quickOrderCreate.orderResult.cloverOrderId );
                    dispatch( 'orders/clearState', null, { root: true } );
                    dispatch( 'orderMenu/clearState', null, { root: true } );
                    router.replace( { name : 'order-success' } );
                } else {

                    throw res.data.message;
                }
            }).catch( err => {

                commit( 'orderError', err );
                dispatch( 'updateLoadingStatus', 'Error Processing!', { root : true } );
                console.log( 'error sending order!', err );
            });
        } else {

            commit( 'orderError', 'This location has been disabled for online orders!' );
            dispatch( 'updateLoadingStatus', 'Error Processing!', { root : true } );
        }
    },
    setTip( { commit, getters }, tipValue ){

        const currentCost = parseFloat( getters.getCost.toFixed( 2 ) );
        const newAmount = currentCost * tipValue;
        commit( 'updateTipValue', tipValue );
        commit( 'updateTip', newAmount );
    },
    toggleTab( { commit, dispatch } ){

        commit( 'toggleTab' );
        router.push( { name: 'order-tab' } );
    },
    processPaymentInfo( { commit, getters, dispatch, rootGetters }, paymentResponse ){

        return new Promise( ( resolve, reject ) => {

            const card = JSON.stringify( paymentResponse );
            const phrase = rootGetters[ 'publicKey' ];

            function encrypt( string, key ) {

                let crypt = new JSEncrypt();
                crypt.setPublicKey( key );
                let encryptedString = crypt.encrypt( string );
                return encryptedString;
            }

            for ( let key in paymentResponse ) {

                let payload = paymentResponse[ key ];
                paymentResponse[ key ] = encrypt( payload, phrase );
            }


            let encDetails = btoa( JSON.stringify( paymentResponse ) );
            if( encDetails ) resolve( encDetails );
            else reject( 'error with card encryption, tell erik so this doesn\'t go to production!' );
        });
    },
    toggleSaveCard( { commit } ){

        commit( 'toggleSaveCard' );
    },
    updateNote( { commit }, value ){

        commit( 'updateNote', value );
    },
    checkAgainstNewMenu( { commit, getters }, newMenu ){

        // console.log( 'checking tab against new menu..', newMenu );
        let newTab = [ ...getters.currentTab ];
        newTab.forEach( tabItem => {

            // console.log( 'tabItem: ', tabItem );
            let newItems = Object.values( newMenu[ 'Items' ] );
            for( let i = 0; i < newItems.length; i++ ){

                // console.log( 'Going through a new Item..' );
                if( newItems[ i ].QuickItem.quickItemId == tabItem.quickItemId ){

                    // console.log( 'Found tabItem within menu data: ', newItems[ i ] );
                    if( [ null, 'null', '', '0', 0 ].includes( newItems[ i ].QuickItem.available ) ){
                        // item no longer available

                        // console.log( 'item is in list but marked unavailable..' );
                        tabItem.available = 0;
                        tabItem.reason = 'Item no longer available';
                    } else if( tabItem.available == 0 && [ true, 'true', '1', 1 ].includes( newItems[ i ].QuickItem.available ) ){

                        // console.log( 'tabItem was made available again' );
                        delete tabItem.available;
                        delete tabItem.reason;
                    }

                    // console.log( 'item found in list, availability is resolved..' );
                    if( tabItem.available != 0 && tabItem.modifiers.length > 0 ) {
                        // availability for the item itself resolved, check modifiers *if there are any*

                        // console.log( 'Checking item modifiers for availability..' );
                        let newMods = Object.values( newMenu[ 'ModifierGroups' ] );
                        // console.log( 'new modifier list: ', newMods );
                        for( let j = 0; j < tabItem.modifiers.length; j++ ){ // go through each tab-item modifier

                            let modArray = tabItem.modifiers[ j ].split( '_' );
                            // console.log( 'tabItem modifier: ', modArray );
                            for( let k = 0; k < newMods.length; k++ ){ // find the group it belongs to

                                if( modArray[ 1 ] == newMods[ k ][ 'QuickModifierGroup' ][ 'quickModifierGroupId' ] ){
                                    // find the modifier it lines up with

                                    let matchedModifier = Object.values( newMods[ k ][ 'QuickModifier' ] ).filter( mod => mod.quickModifierId == modArray[ 3 ] );
                                    // console.log( 'matched modifier: ', matchedModifier );
                                    if( [ null, 'null', '', '0', 0 ].includes( matchedModifier[ 0 ].available ) ){

                                        // console.log( 'this modifier is now marked unavailable' );
                                        modArray[ modArray.length ] = 'unavailable';
                                        tabItem.modifiers[ j ] = modArray.join( '_' );
                                    } else if( modArray[ modArray.length - 1 ] == 'unavailable' && [ true, 'true', '1', 1 ].includes( matchedModifier[ 0 ].available ) ){

                                        // console.log( 'modifier was previously unavailable but made available now..' );
                                        modArray.pop();
                                        tabItem.modifiers[ j ] = modArray.join( '_' );
                                    }
                                    break;
                                }

                                if( k == newMods.length - 1 ){

                                    // console.log( 'modifier made it to end: ', tabItem.modifiers[ j ] );
                                    // console.log( 'item has a modifier that is no longer listed' );
                                    modArray[ modArray.length ] = 'unavailable';
                                    tabItem.modifiers[ j ] = modArray.join( '_' );
                                }
                            }
                        }
                    }

                    break; // matched the item and resolved it's availability state, break and begin searching the next item
                }

                if( i == newItems.length - 1 ){

                    // console.log( 'tabItem made it to end: ', tabItem );
                    // console.log( 'item must not be in the list anymore..' );
                    tabItem.available = 0; // item wasn't found, no longer offered
                    tabItem.reason = 'Item no longer available';
                }
            }
        });
        commit( 'updateTab', newTab );
    }
};

const getters = {

    getCost( state ){

        return state.currentTab.reduce( ( totalTicketAmount, item ) => {

            return item.available == 0 ? totalTicketAmount : totalTicketAmount + parseFloat( item.price );
        }, 0.00 );
    },
    getTax : ( state, getters ) => getters.getCost * state.taxRate,
    orderTip : state => parseFloat( state.orderTip ).toFixed( 2 ),
    tabOpen( state, getters, rootGetters ){

        if(
            state.currentTab.length >= 1
            && ![ 'order-tab', 'payment' ].includes( rootGetters[ 'currentRoute' ].name )
        ) return true;
        return false;
    },
    orderError      : state => state.orderError,
    currentTab      : state => state.currentTab,
    orderTotal      : ( state, getters ) => ( getters.getTax + getters.getCost + parseFloat( getters.orderTip ) ).toFixed( 2 ),
    saveCard        : state => state.saveCard,
    orderNote       : state => state.orderNote,
    tipValue        : state => state.tipValue,
    thisOrderNumber : state => state.thisOrderNumber
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
